import React, { memo, useRef, FC, forwardRef, useImperativeHandle } from "react";
import {
  StyleSheet,
  TextInput,
  View,
  Pressable,
  KeyboardTypeOptions,
  Platform,
} from "react-native";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";

interface SearchFieldProps {
  placeholder: string;
  password?: boolean;
  InputStyle?: any
  keyboardtype?: KeyboardTypeOptions;
  maxLength?: number;
  onTextChange?: (text: string) => void;
  error?: boolean;
  leftIcon?: any;
  other?: any
}

const SearchField: FC<SearchFieldProps> = forwardRef((props, ref) => {
  const {
    placeholder,
    password = false,
    InputStyle,
    keyboardtype,
    maxLength,
    onTextChange,
    error = false,
    leftIcon,
    ...other
  } = props;

  const inputRef = useRef<TextInput>(null);

  const handleTextChange = (text: string) => {
    onTextChange && onTextChange(text); // Call the callback function if provided
  };

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    },
  }));

  return (
    <Pressable onPress={() => inputRef.current?.focus()} style={styles.containerStyle} >
      <View 
        style={
          [styles.searchSection, 
            error && 
            {
              borderColor: Colors.red10,
              borderWidth: 1,
              borderRadius: 8,
            }
          ]}
      >
        {leftIcon}
        <TextInput
          ref={inputRef}
          placeholder={placeholder}
          placeholderTextColor="rgba(0, 0, 0, 0.5)"
          secureTextEntry={password}
          selectionColor={Colors.black100}
          style={[
            GlobalStyles.bodyText,
            styles.input,
            InputStyle,
            Platform.select({
              web: {
                outlineStyle: 'none',
              },
            })
          ]}
          keyboardType={keyboardtype}
          maxLength={maxLength}
          onChangeText={handleTextChange}
          {...other}
        />
      </View>
    </Pressable>
  );
});

export default memo(SearchField);

const styles = StyleSheet.create({
  containerStyle:{
    flex: 1
  },
  searchSection: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    backgroundColor: "#f1f1f1"
  },
  searchIcon: {
    padding: 10,
  },
  input: {
    flex: 1,
    paddingLeft: 20,
    paddingVertical: 10,
    fontSize: 16,
  },
});
